import { CompositeMeterData } from '@models/meter-scans/composite/composite-meter-data';
import { OtdrEvent } from '../otdr-event';
import { OtdrTrace } from '../otdr-trace';

export class OTDRData extends CompositeMeterData {
    port: number;
    timestamp: number;
    mac: string;
    ip: string;
    longitude: number;
    latitude: number;
    events: OtdrEvent[];
    trace: OtdrTrace;
    configUsed: any;
    wavelength: number;

    constructor(
        httpResponse: OTDRData
    ) {
        super();
        this.port = httpResponse.port;
        this.timestamp = httpResponse.timestamp;
        this.mac = httpResponse.mac;
        this.ip = httpResponse.ip;
        this.longitude = httpResponse.longitude;
        this.latitude = httpResponse.latitude;
        this.events = httpResponse.events;
        this.trace = httpResponse.trace;
        this.configUsed = httpResponse.configUsed;
    }
}
